export default {
  contact: {
    description: 'Return a list of my contact information.',
    list: [
      {
        type: 'info',
        label: 'Email:',
        content: 'jarvisg495@gmail.com'
      },
      {
        type: 'info',
        label: 'Github:',
        content: 'https://github.com/JarvisG495'
      },
    ]
  },
  skill: {
    description: 'Return a list of my skills',
    list: [
      // programming
      { type: 'success', label: 'PL', content: '· Python' },
      { type: 'success', label: 'PL', content: '· JavaScript' },
      { type: 'success', label: 'PL', content: '· Typescript' },
      { type: 'success', label: 'PL', content: '· Go' },
      { type: 'warning', label: 'PL', content: '· Shell' },

      // frameworks
      { type: 'success', label: 'Frontend', content: '· React' },
      { type: 'success', label: 'Frontend', content: '· Next.js' },
      { type: 'success', label: 'Backend', content: '· Django' },
    
      // tools
      { type: 'success', label: 'Tool', content: '· Git' },
      { type: 'warning', label: 'Tool', content: '· Docker' },
      
      // services
      { type: 'warning', label: '☁', content: '· AWS' },
      { type: 'warning', label: '☁', content: '· Azure' }
    ]
  },
  education: {
    description: 'Return my education background',
    list: [
      { type:'umass', label:'University of Massachusetts Amherst', content: ' Master of Science in Computer Science (2021.9~2023.5)'},
      { type:'whu', label:'Wuhan University', content: ' Bachelor of Engineering in Software Engineering (2017.9~2021.6)'}
    ]
  },
  hobby: {
    description: 'Return a list of my hobbies',
    list: [
      { type: 'success', label: '⚽😄', content: ' Soccer' },
      { type: 'success', label: '⚫⚪', content: ' The game of Go(weiqi)' },
      { type: 'success', label: '🎹🎵', content: ' Piano' },
      { type: 'success', label: '💻🎮', content: ' Video games!' }
    ]
  },
  copyright: {
    description: 'Return the copyright information of this page',
    list: [
      { 
        type: 'info',
        label: 'COPYRIGHT ©',
        content: ' This page is developed upon react-terminal-app package by Simon Ma.' + 
                 ' I made some customizations and fixed some tiny bugs to meet my personal needs before putting it into use.' +
                 ' If you are interested in having a similar website, please refer to the original package \'react-terminal-app\'.' +
                 ' Also feel free to contact me for getting my personalized modifications.' 
    } ,
    ]
  }
}
